export const EN_DASH_DEFAULT_VALUE = '–'
export const EMPTY_STATE_DROPDOWN = 'dropdown'
export const PHONE_PLACEHOLDER = '(XXX) XXX XXXX'
export const SSN_PLACEHOLDER = '___ - __ - ____'
